import React from 'react';

const Gallery = () => {
  // Your actual lumpia photos in the specified order
  const lumpiaImages = [
    {
      id: 'spliff',
      url: 'https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/8duabyiq_IMG_4138.jpeg',
      name: 'The Spliff',
      description: 'Shrimp Jalapeno Popper',
      price: '$18.00 (12-Pack)'
    },
    {
      id: 'reefer', 
      url: 'https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/wshtcqq0_IMG_4136.jpeg',
      name: 'The Reefer',
      description: 'Crab Rangoon',
      price: '$18.00 (12-Pack)'
    },
    {
      id: 'blunt',
      url: 'https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/k9a9eobf_IMG_4135.jpeg', 
      name: 'The Blunt',
      description: 'Beef & Vegetable',
      price: '$18.00 (12-Pack)'
    },
    {
      id: 'fatty',
      url: 'https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/qm9kmayd_7A29D103-71E4-4FFE-9EC8-D9E25A349DB5.png',
      name: 'The Fatty', 
      description: 'Bacon Jalapeno Popper',
      price: '$18.00 (12-Pack)'
    },
    {
      id: 'pork-shanghai',
      url: 'https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/jri1npom_CB9410E7-28E3-4661-98E3-9615442CCAE8.png',
      name: 'Doobie II',
      description: 'Pork Shanghai', 
      price: '$25.00 (20-Pack)'
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Delicious Creations
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Take a look at our handcrafted lumpia varieties. Each roll is made fresh with premium ingredients 
            and wrapped with love and tradition.
          </p>
        </div>

        {/* Featured Lumpia Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {/* Featured Large Image - The Spliff */}
          <div className="lg:col-span-2 lg:row-span-2">
            <div className="relative group overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 h-full">
              <img 
                src={lumpiaImages[0].url}
                alt={`${lumpiaImages[0].name} - ${lumpiaImages[0].description}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-6 left-6 text-white">
                  <h3 className="text-3xl font-bold mb-2">{lumpiaImages[0].name}</h3>
                  <p className="text-yellow-100 font-medium text-lg mb-2">{lumpiaImages[0].description}</p>
                  <p className="text-blue-200 font-semibold">{lumpiaImages[0].price}</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Smaller Images - Other Varieties */}
          {lumpiaImages.slice(1).map((lumpia, index) => (
            <div key={lumpia.id} className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
              <img 
                src={lumpia.url}
                alt={`${lumpia.name} - ${lumpia.description}`}
                className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 text-white">
                  <h4 className="text-lg font-bold mb-1">{lumpia.name}</h4>
                  <p className="text-yellow-100 text-sm font-medium mb-1">{lumpia.description}</p>
                  <p className="text-blue-200 text-sm font-semibold">{lumpia.price}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="bg-gradient-to-br from-blue-400 to-blue-600 h-48 flex items-center justify-center">
              <div className="text-center text-white">
                <div className="text-4xl mb-4">🌟</div>
                <h4 className="text-lg font-bold mb-2">Premium Quality</h4>
                <p className="text-sm font-medium px-4">Only the finest ingredients in every roll</p>
              </div>
            </div>
          </div>
          
          <div className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="bg-gradient-to-br from-yellow-400 to-amber-400 h-48 flex items-center justify-center">
              <div className="text-center text-gray-900">
                <div className="text-4xl mb-4">🔥</div>
                <h4 className="text-lg font-bold mb-2">Made Fresh</h4>
                <p className="text-sm font-medium px-4">Premium ingredients in every roll</p>
              </div>
            </div>
          </div>
          
          <div className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="bg-gradient-to-br from-yellow-400 to-amber-400 h-48 flex items-center justify-center">
              <div className="text-center text-gray-900">
                <div className="text-4xl mb-4">👨‍🍳</div>
                <h4 className="text-lg font-bold mb-2">Family Recipe</h4>
                <p className="text-sm font-medium px-4">Authentic flavors passed down through generations</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-yellow-100 to-amber-100 rounded-2xl p-8 border-2 border-yellow-300">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Try Our Lumpia?
            </h3>
            <p className="text-gray-800 font-medium mb-6">
              Experience the authentic flavors that make Roll Up Lumpia Co. special
            </p>
            <button 
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors transform hover:scale-105 duration-200 shadow-lg"
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Place Your Order
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;